/**
 * ChartTab — Tab 3 of the patient-edit shell (PROD-735).
 *
 * Mounts the `ChartTabBody` inner-tabbed shell. Flutter ref:
 * `create_patient_screen.dart:1170` → `ChartMainView(showDemogTab: false,
 * showDITab: true, ...)`.
 *
 * Tab content (Allergies, Problems, Procedures, Medications, D/I,
 * Immunizations, Labs, Documents, Notes, Flags, History) ships under
 * PROD-736 / 737 / 738. This ticket scope is the shell only.
 */

import { ChartTabBody } from '@/patients/components/chart/chart-tab-body';
import type { Patient } from '@/types/patient-api';

export interface ChartTabProps {
  patient: Patient | null;
}

export function ChartTab({ patient }: ChartTabProps) {
  // One page by default (Antonin, 15 Oct). The record's Overview and Care plan TABS stay behind `?x=patient-pages`; the
  // chart's own Overview sub-tab does not (it is the chart's first tab unless the URL names one, `chartTab`).
  // The record's chart is a sticky index on the left and every tab on one scrolling page (Overview first; Antonin's export
  // 23 Oct, "Patient · Chart"; it replaced the horizontal track of 21 Oct). The encounter's Chart tab uses the same layout
  // (`EncounterChartPanel`), with its patient panel.
  // No patient panel on the left here: the record's header already names the patient; the panel belongs to the
  // encounter's chart only (Ahmed, 23 Oct).
  return <ChartTabBody patient={patient} onePage layout="index" leftPanel={false} />;
}
